import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propArrayShape, propBool, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import { getFormError, getFormValue } from '../../../../helpers/form';
import { validateOther, validateOtherRequiredWith, validateSelected, } from '../../../../validate/common';
const RadioButtonsWithOther = ({ form, isAfterSelect, name, nameOther, options, otherPlaceHolder, }) => {
    const formValue = getFormValue(form, name);
    const otherValue = (options.find((o) => o.other) || {}).value || '';
    const isOtherSelected = formValue === otherValue.toString();
    const radioError = getFormError(form, name);
    const textError = getFormError(form, nameOther);
    const error = radioError || textError;
    return (_jsx("ul", Object.assign({ className: 'form-solution-select' }, { children: options.map((option) => {
            const id = `${name}#${option.value}`;
            return (_jsxs("li", { children: [_jsx(Field, { component: 'input', name: name, props: {
                            checked: !!(formValue && option.value.toString() === formValue.toString()),
                            className: 'mdc-radio__native-control',
                            id,
                            type: 'radio',
                            value: option.value.toString(),
                        }, validate: validateSelected }), ' ', _jsx("label", Object.assign({ htmlFor: id }, { children: option.label })), option.other && (_jsxs(_Fragment, { children: [_jsx(Field, { component: 'input', name: nameOther, props: {
                                    className: `input-form-text asign-state ${isAfterSelect && 'is-after-select'} ${error && 'is-warning'}`,
                                    disabled: !isOtherSelected,
                                    placeholder: otherPlaceHolder,
                                    type: 'text',
                                }, validate: isOtherSelected ? validateOtherRequiredWith : validateOther }), error && (_jsx("div", { children: _jsx("span", Object.assign({ className: 'font-alert' }, { children: error })) }))] }))] }, id));
        }) })));
};
RadioButtonsWithOther.propTypes = {
    form: propShape().isRequired,
    isAfterSelect: propBool(),
    name: propStr().isRequired,
    nameOther: propStr().isRequired,
    options: propArrayShape().isRequired,
    otherPlaceHolder: propStr(),
};
RadioButtonsWithOther.defaultProps = {
    isAfterSelect: true,
    otherPlaceHolder: '理由をお書きください',
};
export default RadioButtonsWithOther;
